import { render, staticRenderFns } from "./referralStatement.vue?vue&type=template&id=09e97117&scoped=true&"
import script from "./referralStatement.vue?vue&type=script&lang=js&"
export * from "./referralStatement.vue?vue&type=script&lang=js&"
import style0 from "./referralStatement.vue?vue&type=style&index=0&id=09e97117&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e97117",
  null
  
)

export default component.exports